import React from "react";

export default function LegalSectionContent({ section }) {
  return (
    <section id={section.id}>
      <h2>{section.title}</h2>
      <p>{section.content}</p>

      {section.list && (
        <ul>
          {section.list.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )}

      {section.subsections?.map((sub, i) => (
        <div key={i}>
          <h3>{sub.title}</h3>
          <p>{sub.content}</p>
        </div>
      ))}

      {section.afterContent && <p>{section.afterContent}</p>}
    </section>
  );
}
